if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.loadImages();
        this.showActiveMedia();
      }

      // Keep large image URLs inert until the customer opens the zoom dialog.
      // Variant updates replace modal contents, so hydrate the current images each time.
      loadImages() {
        this.querySelectorAll('img[data-modal-src]').forEach((image) => {
          if (image.dataset.modalSrcset) {
            image.setAttribute('srcset', image.dataset.modalSrcset);
            image.removeAttribute('data-modal-srcset');
          }
          image.setAttribute('src', image.dataset.modalSrc);
          image.removeAttribute('data-modal-src');
        });
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
